const toneClass = {
  primary: 'bg-action-primary',
  danger: 'bg-status-danger',
  warning: 'bg-status-warning',
  success: 'bg-status-success',
  neutral: 'bg-text-secondary',
} as const;

type DotProps = {
  tone: keyof typeof toneClass;
  size?: number;
  className?: string;
};

export function Dot({ tone, size = 8, className = '' }: DotProps) {
  return (
    <span
      className={`inline-block shrink-0 rounded-full ${toneClass[tone]} ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
